import { render, staticRenderFns } from "./dealerList.vue?vue&type=template&id=128ba2ab&"
import script from "./dealerList.vue?vue&type=script&lang=js&"
export * from "./dealerList.vue?vue&type=script&lang=js&"
import style0 from "./dealerList.vue?vue&type=style&index=0&id=128ba2ab&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128ba2ab')) {
      api.createRecord('128ba2ab', component.options)
    } else {
      api.reload('128ba2ab', component.options)
    }
    module.hot.accept("./dealerList.vue?vue&type=template&id=128ba2ab&", function () {
      api.rerender('128ba2ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/dealerList.vue"
export default component.exports